// 注册ccui组件
import {
  AdvancedDatePicker,
  AdvancedSelector,
  AdvancedUnitSelector,
  AdvancedUserSelector,
  AllSubLevelUnitSelector,
  AreaSelector,
  Aside,
  Autocomplete,
  BottomGuide,
  Breadcrumb,
  BreadcrumbItem,
  Button,
  ButtonGroup,
  Card,
  CardTitle,
  Cascader,
  Checkbox,
  CheckboxGroup,
  CheckboxTableChecked,
  Col,
  DatePicker,
  DetailInfo,
  Dialog,
  DialogTreeTable,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  ExportButton,
  Form,
  FormItem,
  GroupTitle,
  Image,
  Input,
  InputNumber,
  Kindeditor,
  Label,
  Loading,
  MaterialCatalog,
  Menu,
  MenuItem,
  Message,
  MessageBox,
  MobileEditor,
  Option,
  OrgTree,
  Pagination,
  PlainOrgSelector,
  Popover,
  Radio,
  RadioButton,
  RadioButtonGroup,
  RadioGroup,
  Rate,
  RegionSelector,
  RegionSelectorG,
  Row,
  Scrollbar,
  Search,
  Select,
  SelfUnitUserSelector,
  SimpleFooter,
  SingleSelect,
  SortingSelector,
  StatisticsCard,
  Step,
  Steps,
  SubLevelUnitSelector,
  SubLevelUserSelector,
  Submenu,
  Switch,
  SwitchComponent,
  TabButton,
  Table,
  TableColumn,
  TabPane,
  Tabs,
  Tag,
  Timeline,
  TimelineItem,
  TimePicker,
  Tooltip,
  TopNavMenu3,
  TopNavMenu6,
  Tree,
  TreeSelector,
  Upload
} from "ccui";
import "ccui/lib/theme-chalk/index.css"; // CCUI样式

export default {
  install: (Vue, options) => {
    Vue.use(Step);
    Vue.use(Steps);
    Vue.use(Rate);
    Vue.use(SelfUnitUserSelector);
    Vue.use(SubLevelUserSelector);
    Vue.use(SubLevelUnitSelector);
    Vue.use(AdvancedUserSelector);
    Vue.use(AdvancedUnitSelector);
    Vue.use(Tooltip);
    Vue.use(Table);
    Vue.use(TableColumn);
    Vue.use(Pagination);
    Vue.use(MaterialCatalog);
    Vue.use(Tree);
    Vue.use(Input);
    Vue.use(AdvancedSelector);
    Vue.use(Aside);
    // Vue.use(TimeoutLogin);
    Vue.use(PlainOrgSelector);
    Vue.use(CardTitle);
    // Vue.use(TimelineApproval);
    // Vue.use(TopNavMenu);
    Vue.use(MenuItem);
    // Vue.use(HistoryList);
    Vue.use(Menu);
    Vue.use(Scrollbar);
    Vue.use(Submenu);
    Vue.use(Timeline);
    Vue.use(TimelineItem);
    Vue.use(Autocomplete);
    Vue.use(Col);
    Vue.use(Row);
    Vue.use(Label);
    Vue.use(Loading);
    // Vue.use(PlainSearch);
    // Vue.use(Progress);
    Vue.use(Card);
    Vue.use(Tag);
    // Vue.use(DataCard);
    Vue.use(Breadcrumb);
    Vue.use(BreadcrumbItem);
    // Vue.use(Alert);
    Vue.use(Button);
    Vue.use(Popover);
    Vue.use(CheckboxGroup);
    Vue.use(Checkbox);
    Vue.use(Form);
    Vue.use(FormItem);
    // Vue.use(TagSelector);
    Vue.use(Select);
    Vue.use(Option);
    Vue.use(Search);
    // Vue.use(TopNavMenu2);
    Vue.use(TopNavMenu3);
    Vue.use(TopNavMenu6);
    // Vue.use(MerchantSelector);
    Vue.use(DatePicker);
    // Vue.use(InputTagDatePicker);
    Vue.use(DetailInfo);
    Vue.use(TimePicker);
    Vue.use(Radio);
    // Vue.use(RadioButton);
    Vue.use(RadioGroup);
    Vue.use(Dialog);
    Vue.use(SimpleFooter);
    Vue.use(TreeSelector);
    Vue.use(StatisticsCard);
    Vue.use(AdvancedDatePicker);
    Vue.use(Tabs);
    Vue.use(TabPane);
    Vue.use(Switch);
    Vue.use(Image);
    Vue.use(SwitchComponent);
    Vue.use(DropdownMenu);
    Vue.use(Dropdown);
    Vue.use(DropdownItem);
    Vue.use(BottomGuide);
    Vue.use(Cascader);
    Vue.use(ExportButton);
    Vue.use(Upload);
    Vue.use(ButtonGroup);
    Vue.use(MobileEditor);
    Vue.use(InputNumber);
    Vue.use(SortingSelector);
    Vue.use(OrgTree);
    Vue.use(AreaSelector);
    Vue.use(Kindeditor);
    // Vue.use(EmpFooter);
    Vue.use(RegionSelector);
    Vue.use(RegionSelectorG);
    Vue.use(GroupTitle);
    Vue.use(SingleSelect);
    Vue.use(DialogTreeTable);
    Vue.use(CheckboxTableChecked);
    Vue.use(AllSubLevelUnitSelector);
    Vue.use(TabButton);
    Vue.use(RadioButtonGroup);
    Vue.use(RadioButton);
    Vue.prototype.$message = Message;
    window.$message = Message;
    Vue.prototype.$confirm = MessageBox.confirm;
    Vue.prototype.$alert = MessageBox;
  }
};
